export default __webpack_public_path__ + "static/media/ban.37428345.svg";